import {ViewPopup} from './ViewPopup'
import {createDivIn, createImgIn, createParagraphIn, createSpanIn, setElementInnerHTML} from '../ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {Sound} from '../Sound'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {isMobileLandscapeView} from '../ui_utils/ClientUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {clientI18n} from '../ClientI18n'
import {TranslationArrayKeys} from '@colonist/i18n'
import {ViewPopupLogin} from './ui_popup_membership_incentive/ViewPopupLogin'

export class ViewPopupLoginIncentive extends ViewPopup {
    private readonly loginButtonsDiv: HTMLDivElement

    constructor(checkAction: () => void, xAction: () => void, removeAction: () => void) {
        super({key: 'strings:popups.login.createFreeAccount'}, {key: 'strings:colonistCommon.utils.emptyString'}, checkAction, xAction, true)

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        this.body.className = 'popup-body-login-incentive'

        const shouldMakeLarge = isMobileLandscapeView() || UIUtilsEjsVariables.isUserOnMobileApp
        if(shouldMakeLarge) this.makeLarge()

        const loginPerkPopupWrapper = createDivIn(this.body, 'popup-login-incentive-wrapper', '')

        if(!shouldMakeLarge) {
            const loginPerksDiv = createDivIn(loginPerkPopupWrapper, 'popup-login-incentive', '')
            const perkTranslationKeys: TranslationArrayKeys[] = ['strings:popups.login.perks.addFriends', 'strings:popups.login.perks.trackStats', 'strings:popups.login.perks.accessMore', 'strings:popups.login.perks.playRanked']

            for(const perkKey of perkTranslationKeys) {
                const [textLine1, textLine2] = clientI18n.tArray(perkKey)
                const perkDiv = createDivIn(loginPerksDiv, 'popup-login-perk', '')
                const perkCheckDiv = createDivIn(perkDiv, '', '')
                createImgIn(perkCheckDiv, LobbyImage.CheckMark)
                const perkTextDiv = createDivIn(perkDiv, '', '')
                createParagraphIn(perkTextDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `${textLine1} `}}, '', '')
                createSpanIn(perkTextDiv, '', {key: 'strings:colonistCommon.utils.#buffer', options: {value: textLine2}})
            }
        }

        this.loginButtonsDiv = createDivIn(loginPerkPopupWrapper, 'popup-login-buttons', '')
        this.removeAction = removeAction

        this.createLoginButtons()
        this.removeFooter()
        this.show()
    }

    private createLoginButtons() {
        const googleLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-google-btn', '')
        createImgIn(googleLogin, LobbyImage.GoogleIcon)
        createSpanIn(googleLogin, '', {key: 'strings:popups.login.continueWith', options: {context: 'google'}})

        const discordLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-discord-btn', '')
        createImgIn(discordLogin, LobbyImage.DiscordIcon)
        createSpanIn(discordLogin, '', {key: 'strings:popups.login.continueWith', options: {context: 'discord'}})

        const appleLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-apple-btn', '')
        createImgIn(appleLogin, LobbyImage.AppleIcon)
        createSpanIn(appleLogin, '', {key: 'strings:popups.login.continueWith', options: {context: 'apple'}})

        const continueAsGuest = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-continue-btn', '')
        const continueAsGuestText = createSpanIn(continueAsGuest, '', {key: 'strings:popups.login.continueAsGuest'})

        googleLogin.onclick = ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.googleAuth())
        discordLogin.onclick = ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.discordAuth())
        appleLogin.onclick = ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.appleAuth())

        continueAsGuestText.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
        }
    }
}
